export const isValidSourceId = (sourceId?: string) => {
  if (!sourceId) return false;
  else if (sourceId === '00000000-0000-0000-0000-000000000000') return false;
  return true;
};
